<script setup>
import useContratos from "@/composables/useContratos";
import Multiselect from "vue-multiselect";
const {
  loadingClientes,
  fetchClientes,
  clientes,
  storeContratoDomiciliacion,
  cliente,
  loadingButton,
} = useContratos();

fetchClientes();
</script>

<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0 border-bottom">
            <div class="d-flex justify-content-center align-items-center">
              <div class="col-md-12"><h6>Nuevo contrato domiciliación</h6></div>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2 vh-50">
            <div class="container py-4">
              <form
                class="w-100 px-md-5"
                method="POST"
                id="formContrato"
                @submit.prevent="storeContratoDomiciliacion"
              >
                <div class="row">
                  <div class="form-group col-md-6">
                    <label for="nombre_titular_cuenta"
                      >Nombre titular de cuenta:</label
                    >
                    <input
                      type="text"
                      name="nombre_titular_cuenta"
                      class="form-control"
                      id="nombre_titular_cuenta"
                      autocomplete="off"
                      required
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label for="correo_titular_cuenta"
                      >Correo titular cuenta:</label
                    >
                    <input
                      type="email"
                      name="correo_titular_cuenta"
                      class="form-control"
                      id="correo_titular_cuenta"
                      autocomplete="off"
                      required
                      placeholder="correo@ejemplo.com"
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label for="nombre_titular_servicio"
                      >Nombre titular de cuenta:</label
                    >
                    <input
                      type="text"
                      name="nombre_titular_servicio"
                      class="form-control"
                      id="nombre_titular_servicio"
                      autocomplete="off"
                      required
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label for="correo_titular_servicio"
                      >Correo titular cuenta:</label
                    >
                    <input
                      type="email"
                      name="correo_titular_servicio"
                      class="form-control"
                      id="correo_titular_servicio"
                      autocomplete="off"
                      required
                      placeholder="correo@ejemplo.com"
                    />
                  </div>
                  <div class="form-group col-md-6 position-relative">
                    <label>Cliente*</label>
                    <Multiselect
                      v-model="cliente"
                      :options="clientes"
                      :value="[clientes]"
                      :searchable="true"
                      label="label"
                      track-by="id"
                      required
                      placeholder="Seleccione"
                      :object="true"
                      :disabled="loadingClientes"
                    ></Multiselect>
                    <div
                      class="spinner-border text-primary spinner-border-sm position-absolute bottom-10 mb-1 end-4"
                      role="status"
                      v-if="loadingClientes"
                    >
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Descripción*</label
                    ><input
                      type="text"
                      class="form-control"
                      name="descripcion"
                      required=""
                      autocomplete="off"
                    />
                  </div>
                  <div class="form-group col-md-3">
                    <label>Periodo facturación*</label>
                    <select
                      name="periodo"
                      id="periodo"
                      class="form-control"
                      required
                    >
                      <option value="">Seleccione</option>
                      <option value="SEMANAL">SEMANAL</option>
                      <option value="QUINCENAL">QUINCENAL</option>
                      <option value="MENSUAL">MENSUAL</option>
                      <option value="BIMESTRAL">BIMESTRAL</option>
                      <option value="SEMESTRAL">SEMESTRAL</option>
                      <option value="ANUAL">ANUAL</option>
                    </select>
                  </div>
                  <div class="form-group col-md-3">
                    <label>Banco*</label
                    ><input
                      type="text"
                      class="form-control"
                      name="banco"
                      required=""
                      autocomplete="off"
                    />
                  </div>
                  <div class="form-group col-md-3">
                    <label>Cuenta*</label
                    ><input
                      type="tel"
                      class="form-control"
                      name="cuenta"
                      required
                      autocomplete="off"
                    />
                  </div>
                  <div class="form-group col-md-3">
                    <label>Clabe*</label
                    ><input
                      type="tel"
                      class="form-control"
                      name="clabe"
                      required
                      autocomplete="off"
                    />
                  </div>
                  <div class="form-group col-md-3">
                    <label>Monto máximo*</label
                    ><input
                      type="tel"
                      class="form-control"
                      name="monto_maximo"
                      required=""
                      placeholder="00.00"
                      autocomplete="off"
                    />
                  </div>
                  <div class="form-group col-md-3">
                    <label>Vencimiento</label
                    ><input
                      type="date"
                      class="form-control"
                      name="vencimiento"
                      placeholder="Opcional"
                      autocomplete="off"
                    />
                  </div>
                  <div class="form-group col-md-3">
                    <label>No. Cliente</label>
                    <input
                      type="text"
                      class="form-control"
                      name="no_cliente"
                      placeholder="Opcional"
                      autocomplete="off"
                    />
                  </div>
                  <div class="form-group col-md-3">
                    <label>No. Contrato</label>
                    <input
                      type="text"
                      name="no_contrato"
                      placeholder="Opcional"
                      class="form-control"
                      autocomplete="off"
                    />
                  </div>
                  <div class="text-center mt-1">
                    <button
                      type="submit"
                      class="btn btn-primary me-2 btn-sm"
                      :disabled="loadingButton"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                        v-if="loadingButton"
                      ></span>
                      Guardar
                    </button>
                    <router-link
                      :to="{ name: 'contrato-domiciliacion' }"
                      class="active btn btn-danger text-white btn-sm"
                      >Cancelar</router-link
                    >
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
